<script>
const debug = false;
export default {
  debug,
};
</script>